import {Injectable} from '@angular/core';
import {HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";
import {DigitalOutStatus} from "./digitalOutStatus";
import {UrlBuilder} from "../url-builder/url.builder";


@Injectable({
  providedIn: 'root'
})
export class DigitaloutStatusDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<DigitalOutStatus> {
    this.uiUrl = this.url.GetDigitalOutStatusUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<DigitalOutStatus>(this.uiUrl);
  }

}


